import { z } from 'zod';
import { Product } from './product';
import { Category } from './category';
import { Offer } from './offer';

export enum AffiliationConfigModes {
  'Não liberado' = 'OFF',
  'Todos' = 'ALL',
  'Mediante aprovação' = 'BY_REQUEST',
  'Liberado para todos' = 'UNRESTRICTED',
}

export enum AffiliationConfigOrderBy {
  'Mais recentes' = 'MOST_RECENT',
  'Campeões de vendas' = 'RANKING',
}

export const affiliationConfigSchema = z.object({
  id: z.number(),
  botConfigId: z.number(),
  description: z.string(),
  supportContact: z.string(),
  mode: z.nativeEnum(AffiliationConfigModes),
  commissionRate: z.number().min(0.01).max(1),
});
export type AffiliationConfig = z.infer<typeof affiliationConfigSchema>;

export const affiliationConfigToUpdateSchema = affiliationConfigSchema.omit({
  id: true,
  botConfigId: true,
});
export type AffiliationConfigToUpdate = z.infer<
  typeof affiliationConfigToUpdateSchema
>;

export type AffiliationMarketProduct = AffiliationConfig & {
  name: Product['name'];
  sellerName?: Product['sellerName'];
  image: Product['image'];
  categoryId: Category['id'];
  categoryName: Category['name'];
  productCode: Product['code'];
  maxCommissionValue: Offer['value'];
  marketplaceUrl: string;
};

export type AffiliationMarketFilters = {
  name?: string;
  mode?: AffiliationConfigModes;
  commissionRateStart?: number;
  commissionRateEnd?: number;
  orderBy?: AffiliationConfigOrderBy;
  category?: string;
};

export type AffiliationMarketFiltersForForm = Omit<
  AffiliationMarketFilters,
  'commissionRateStart' | 'commissionRateEnd'
> & { commissionRate: [number, number] };
